import AddDevoteeDetailsView from "../../../Views/CheckoutV2/AddDevotee/AddDevoteeView";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { truncateToTwoDecimals } from "../../../utils/HelperFunctions";
import { useNavigate } from "react-router-dom";
import {
  getCurrentTimeUtc,
  getCurrentUTCDate,
  getDeviceInfo,
  uid,
} from "../../../utils/HelperFunctions";
import { addAndUpdateCartItem } from "../../../store/actions/cartAction";
import CartNoItem from "../../../components/card/Cart/NoItemInCart";
import { getUserOrder } from "../../../store/actions/orderAction";
import {
  getOrderQuantityClertap,
  getTotalCartPrice,
  trackCleavertapEvent,
} from "../../../utils/analyics/analyticsHelper";
import { ANALYTICS_EVENTS } from "../../../utils/analyics/analyticsEvents";

function AddDevoteeDetailsScreen() {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const { selectedPuja, selectedTempleDetailsForPuja } = useSelector(
    (state: any) => state.puja,
  );

  const { cartInfo } = useSelector((state: any) => state.cart);
  var { userInfo } = useSelector((state: any) => state.user);
  const { countryCode } = useSelector((state: any) => state.auth);
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion,
  );
  const { rate = 1, isOverseas = false } =
    priceConversionState.priceConversionRate || {};
  const userPersonalInfo =
    userInfo && userInfo.personalInfo ? userInfo.personalInfo : null;
  const { tempCartPayLoad } = useSelector((state: any) => state.cart);
  const [cartId, setCartId] = useState<string>("");
  var { userInfo } = useSelector((state: any) => state.user);
  const [singleCartData, setSingleCartData] = useState<any>();

  const [whatsAppNumber, setWhatsAppNumber] = useState("");
  const [selectedDialCode, setSelectedDialCode] = useState("");
  const [selectedCountryForWhatapp, setSelectedCountryForWhatapp] =
    useState("");
  const [isAutoFilled, setIsAutoFilled] = useState(false);
  const [isWhatsAppAutoFilled, setIsWhatsAppAutoFilled] = useState(false);

  const getResolvedWhatsAppNumber = () => {
    if (whatsAppNumber) {
      return whatsAppNumber;
    }
    const fallback = userInfo?.phoneNumber?.replace(/\D/g, "");
    return fallback ? fallback.slice(-10) : "";
  };

  useEffect(() => {
    setSingleCartData(tempCartPayLoad);
    setCartId(tempCartPayLoad?.cartId);
  }, [tempCartPayLoad]);

  useEffect(() => {
    setWhatsAppNumber(singleCartData?.whatsAppNumber);
    setSelectedDialCode(singleCartData?.dialCode);
    setSelectedCountryForWhatapp(singleCartData?.whatsAppCountryCode);
  }, [singleCartData]);

  const [gotram, setGotram] = useState<string>("");
  const [manokamna, setmanokamna] = useState<string>("");
  const [membersInfo, setMembersInfo]: any = useState([]);
  const [isDefaultChadhavaNote, setIsDefaultChadhavaNote] =
  useState<boolean>(false);
  const [popUpDevoteePreviousBooking, setPopUpDevoteePreviousBooking]: any =
    useState(false);
  const currentPujaDetails = selectedPuja ? selectedPuja : {};
  const currentTempleDetails = selectedTempleDetailsForPuja
    ? selectedTempleDetailsForPuja
    : {};

  useEffect(() => {
    if (singleCartData) {
      let oneCartData = { ...singleCartData };
      let maxMemberAllowed = 1;
      if (
        oneCartData?.selectedPujaPackage?.maxMemberAllowed ||
        oneCartData?.pujaDetails?.maxMemberAllowed
      ) {
        maxMemberAllowed = Number(
          oneCartData?.selectedPujaPackage?.maxMemberAllowed ||
            oneCartData?.pujaDetails?.maxMemberAllowed,
        );
      }

      let tempmembersInfo: any = [];

      if (
        oneCartData?.membersData &&
        oneCartData?.membersData?.length &&
        oneCartData?.membersData[0]?.gotram
      ) {
        setGotram(oneCartData?.membersData[0]?.gotram);
      }

      for (let i = 0; i < maxMemberAllowed; i++) {
        if (
          oneCartData &&
          oneCartData?.membersData &&
          oneCartData?.membersData &&
          oneCartData?.membersData.length > 0 &&
          oneCartData?.membersData[i]
        ) {
          tempmembersInfo = [...tempmembersInfo, oneCartData?.membersData[i]];
        } else {
          tempmembersInfo = [
            ...tempmembersInfo,
            { id: uid(), fullName: "", gotram: "" },
          ];
        }
      }
      setMembersInfo(tempmembersInfo);
      setmanokamna(oneCartData?.additionalDetails);
    }
  }, [singleCartData]);

  const updateMemberInfo = (key: any, info: any) => {
    let tempmemberData = [...membersInfo];
    tempmemberData[key] = info;
    setMembersInfo(tempmemberData);
  };
  const [whatsAppNumberError, setWhatsAppNumberError] =
    useState<boolean>(false);

  const [fullNameError, setFullNameError] = useState<boolean>(false);
  const isValidForm = (): boolean => {
    const resolvedNumber = getResolvedWhatsAppNumber();
    const whatsappNumberRegex = /^[0-9]{10}$/;

    if (!whatsappNumberRegex.test(resolvedNumber)) {
      setWhatsAppNumberError(true);
      return false;
    }
    if (!membersInfo || membersInfo.length <= 0) {
      setFullNameError(true);
      return false;
    }
    if (
      (!membersInfo && membersInfo.length === 0 && !membersInfo[0]?.fullName) ||
      membersInfo[0]?.fullName?.length < 2
    ) {
      setFullNameError(true);
      return false;
    }
    setFullNameError(false);
    setWhatsAppNumberError(false);
    return true;
  };

  useEffect(() => {
    setWhatsAppNumberError(false);
  }, [whatsAppNumber]);

  const proceedToCart = async () => {
    if (!isValidForm()) {
      return false;
    }

    let enteredmembersInfo = [];
    for (let i = 0; i < membersInfo.length; i++) {
      let tempMember: any = Object.assign({}, membersInfo[i]);
      //-----------------------------
      if (gotram?.trim()?.length > 0) {
        tempMember["gotram"] = gotram;
      } else {
        tempMember["gotram"] = "Kashyapa";
      }
      if (manokamna?.trim()?.length > 0) {
        tempMember["additionalDetails"] = manokamna;
      }
      //-----------------------------

      if (membersInfo[i].fullName) {
        enteredmembersInfo.push(tempMember);
      }
    }

    const deviceInfo = getDeviceInfo();

    let cartPayload = {
      ...singleCartData,
      membersData: enteredmembersInfo,
      whatsAppNumber: getResolvedWhatsAppNumber(),
      whatsAppNumberdialCode: "+" + selectedDialCode,
      whatsAppCountryCode: selectedCountryForWhatapp,
      deviceType: "WEB",
      cartAddDateAndTime: {
        date: getCurrentUTCDate(),
        time: getCurrentTimeUtc(),
      },
      templeId: singleCartData?.templeDetails?.id,
      deviceDetails: deviceInfo,
      bookedForDate: singleCartData?.bookedForDate,
      isPrasad: false,
      gotram: gotram,
      additionalDetails: manokamna,
    };
    const tempPriceInf = cartPayload?.tempPriceInfo;
    delete cartPayload?.tempPriceInfo;
    delete cartPayload?.pujaDateTime;
    if (cartId) {
      const isEdit = cartInfo?.some((item: any) => item?.cartId === cartId);
      let _priceValue = isOverseas
        ? truncateToTwoDecimals((tempPriceInf?.finalPrice ?? 0) * rate)
        : tempPriceInf?.finalPrice;
      if (isEdit) {
        _priceValue = isOverseas
          ? truncateToTwoDecimals(
              (cartPayload?.priceInfo?.finalPrice ?? 0) * rate,
            )
          : cartPayload?.priceInfo?.finalPrice;
      }

      const analyticsPayload = {
        User_ID: userInfo?.id ?? "Guest User",
        Cart_ID: cartId,
        Item_Type: cartPayload?.orderType,
        Item_ID: cartPayload?.pujaDetails?.pujaNameKey ?? "",
        Item_Name:
          cartPayload?.pujaDetails?.pujaName ??
          cartPayload?.templeDetails?.chadhavaTitle ??
          "",
        Temple_ID: cartPayload?.templeDetails?.nameKey ?? "",
        Temple_Name: cartPayload?.templeDetails?.personalInfo?.name ?? "",
        Price: _priceValue ?? 0,
        Quantity: getOrderQuantityClertap(cartPayload),
        Currency:
          priceConversionState?.priceConversionRate?.currencyCode ?? "INR",
        Cart_Size: isEdit ? cartInfo?.length : (cartInfo?.length ?? 0) + 1,
        Cart_Value: isOverseas
          ? truncateToTwoDecimals(getTotalCartPrice(cartInfo) * rate)
          : (getTotalCartPrice(cartInfo) ?? 0),
        IsOverseas: isOverseas,
        rate: rate ?? 1,
        IsPrasad: cartPayload?.isPrasad ?? false,
        Source_Page: isEdit ? "Checkout Page" : cartPayload?.orderType,
        IsSubscribed: cartPayload?.isSubscribed ? true : false,
      };
      if (isEdit) {
        trackCleavertapEvent(
          ANALYTICS_EVENTS.Cart_Item_Updated,
          analyticsPayload,
        );
      } else {
        trackCleavertapEvent(ANALYTICS_EVENTS.Add_to_Cart, analyticsPayload);
        trackCleavertapEvent(ANALYTICS_EVENTS.Checkout_Initiated, analyticsPayload);

      }
      dispatch(
        addAndUpdateCartItem(userInfo?.phoneNumber, cartId, cartPayload),
      );
      //  await CartService.addToCart(userInfo?.phoneNumber,cartPayload)
      navigate(`/checkoutV2/reviewCart?cartId=${cartId}`);
    }
  };

  const [prevUserGroup, setPrevUserGroup] = useState<any>([]);
  const { userOrder } = useSelector((state: any) => state.order);
  useEffect(() => {
    if (userInfo) {
      // Pehle check karo ki userInfo exist karta hai
      dispatch(getUserOrder(userInfo))
        .then((data: any) => {})
        .catch((error: any) => {});
    }
  }, [userInfo]);

  useEffect(() => {
    let groupDetails: any[] = [];

    if (userOrder.length) {
      groupDetails = userOrder.reduce((acc: any[], el: any, index: number) => {
        return [...acc, ...(el?.orderUserDetails?.groupDetails ?? [])];
      }, []);
    }
    setPrevUserGroup(groupDetails);
  }, [userOrder]);

  useEffect(() => {
    if (!membersInfo || membersInfo?.length === 0) return;
    const AutoFillFirstDevotee = membersInfo[0];
    const userFullName = `${userPersonalInfo?.firstName || ""} ${
      userPersonalInfo?.lastName || ""
    }`?.trim();
    if (!isAutoFilled && !AutoFillFirstDevotee?.fullName && userFullName) {
      updateMemberInfo(0, { ...AutoFillFirstDevotee, fullName: userFullName });
      setIsAutoFilled(true);
    }
  }, [membersInfo, userPersonalInfo]);

  useEffect(() => {
    if (!userInfo?.phoneNumber || !countryCode?.length) return;
    let fullPhoneDigits = userInfo?.phoneNumber?.replace(/\D/g, "");
    if (!fullPhoneDigits) return;

    const extractedPhoneNumber = fullPhoneDigits?.slice(-10);
    const extractedDialCode = fullPhoneDigits?.slice(
      0,
      fullPhoneDigits?.length - 10,
    );

    if (!isWhatsAppAutoFilled && extractedPhoneNumber && !whatsAppNumber) {
      setWhatsAppNumber(extractedPhoneNumber);
      setIsWhatsAppAutoFilled(true);
    }
    if (extractedDialCode && !selectedDialCode) {
      setSelectedDialCode(extractedDialCode);
    }
    if (extractedDialCode) {
      const matchedCountry = countryCode.find((country: any) => {
        return country?.dial_code.replace("+", "") === extractedDialCode;
      });

      if (matchedCountry && !selectedCountryForWhatapp) {
        setSelectedCountryForWhatapp(matchedCountry?.code);
      }
    }
  }, [userInfo, countryCode]);

  const selectPrevGroupMember = (selectedPrevMemberInfo: any) => {
    let tempmembersInfo: any = JSON.parse(JSON.stringify(membersInfo));
    membersInfo?.some((member: any, index = 0) => {
      if (membersInfo.length === 1) {
        tempmembersInfo[0].fullName = "";
      }
      if (!tempmembersInfo[index].fullName) {
        if (selectedPrevMemberInfo?.fullName) {
          tempmembersInfo[index].fullName = selectedPrevMemberInfo.fullName;
        } else {
          // console.warn("selectedPrevMemberInfo is undefined or has no fullName");
        }
        return true;
      }
      return false;
    });

    setMembersInfo(tempmembersInfo);
    setPopUpDevoteePreviousBooking(false);
  };

  const [isGotramChecked, setIsGotramChecked] = useState<boolean>(false);

  useEffect(() => {
    if (isGotramChecked) {
      setGotram("Kashyap");
    } else {
      setGotram("");
    }
  }, [isGotramChecked]);

  return (
    <div>
      {singleCartData ? (
        <AddDevoteeDetailsView
          cartInfo={[singleCartData]}
          pujaDetails={currentPujaDetails}
          templeDetails={currentTempleDetails}
          membersInfo={membersInfo}
          updateMemberInfo={updateMemberInfo}
          proceedToCart={proceedToCart}
          whatsAppNumber={whatsAppNumber}
          setWhatsAppNumber={setWhatsAppNumber}
          selectPrevGroupMember={selectPrevGroupMember}
          prevUserGroup={prevUserGroup}
          setPopUpDevoteePreviousBooking={setPopUpDevoteePreviousBooking}
          popUpDevoteePreviousBooking={popUpDevoteePreviousBooking}
          addmanokamna={setmanokamna}
          addGotram={setGotram}
          gotram={gotram}
          manokamna={manokamna}
          isDefaultChadhavaNote={isDefaultChadhavaNote}
          setIsDefaultChadhavaNote={setIsDefaultChadhavaNote}
          whatsAppNumberError={whatsAppNumberError}
          fullNameError={fullNameError}
          selectedDialCode={selectedDialCode}
          setSelectedDialCode={setSelectedDialCode}
          selectedCountryForWhatapp={selectedCountryForWhatapp}
          setSelectedCountryForWhatapp={setSelectedCountryForWhatapp}
          checked={isGotramChecked}
          handleChange={(e: any) => setIsGotramChecked((prev) => !prev)}
          userPersonalInfo={userPersonalInfo}
          isWhatsAppAutoFilled={isWhatsAppAutoFilled}
          setIsWhatsAppAutoFilled={setIsWhatsAppAutoFilled}
        />
      ) : (
        <CartNoItem />
      )}
    </div>
  );
}

export default AddDevoteeDetailsScreen;
